<template>
  <b-card no-body>
    <b-card-body>
      <provider-additional-fee-detail
        ref="providerAdditionalFeeDetail"
        type="new"
        :submitting="submitting"
        @submit="submit"
      />
    </b-card-body>
  </b-card>
</template>
<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { BCard, BCardBody } from 'bootstrap-vue';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import ProviderAdditionalFeeDetail from '@/views/pages/providers/ProviderAdditionalFeeDetail.vue';

export default {
  components: {
    BCard,
    BCardBody,
    ProviderAdditionalFeeDetail
  },
  mixins: [helper],

  data() {
    return {
      submitting: false,
      data: {}
    };
  },
  methods: {
    submit(data) {
      const id = parseInt(this.$route.params.id);
      this.submitting = true;

      useService
        .createProviderFee(id, data)
        .then(response => {
          this.showSuccessMessage(`${response.message}`);
          this.$refs.providerAdditionalFeeDetail.resetForm();
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
